import styled from 'styled-components'
import { typo } from '../styles/fonts'
import colors from '../styles/colors'

function VideoMapPopup( { iframeTitle, embed } ) {
  return (
    <StyledBlueSpaceMarker>
      <StyledIframe>
        <iframe title={ iframeTitle } width="315" height="560" src={ embed } allowFullScreen />
      </StyledIframe>
    </StyledBlueSpaceMarker>
  )
}

const StyledBlueSpaceMarker = styled.div`
  padding: 0;
  margin: 0;

  h3 {
    margin: 0;
    padding: 0.5rem 1rem;
    ${ typo.diaryNotes }
    font-size: ${ typo.sizes.bumped };
    background: ${ colors.navy };
    color: ${ colors.white };
  }
`

const StyledIframe = styled.div`
  iframe {
    width: 100%;
    aspect-ratio: 315 / 560;
    height: auto;
    border: none;
    display:block;
  }
`

export default VideoMapPopup
